import axios from "axios";
import React from "react";
import { UploadLink } from "../../helpers/uri";
import is_null from "../../helpers/is_null";
import swal from "../../helpers/swal";
import { axiospost } from "../../helpers/httprequest";
import Loader from "../../components/Loader";
import { useQueryClient } from "@tanstack/react-query";

const UploadDoc = ({ r }) => {
  const [loading, setloading] = React.useState(false);
  const queryClient = useQueryClient();
  const _save = async (e) => {
    try {
      setloading(true);
      const fd = new FormData();
      fd.append("photo", e.target.files[0]);
      const upload = await axios.post(UploadLink, fd);
      if (!is_null(upload?.data)) {
        if (upload.data?.type === "error") {
          throw new Error(upload.data?.message);
        }
      }
      let pix = upload.data;

      const req = await axiospost(`ms_application_uploads`, {
        requirement: r._id,
        uri: pix,
      });
      if (req.status !== 200) throw new Error("Sorry something went wrong, please try again");
      const { type, message } = req.data;
      queryClient.invalidateQueries({ queryKey: ["admissionRequirementforCourse"] });
      swal(type, message);
      setloading(false);
    } catch ({ message }) {
      swal("error", message);
      setloading(false);
    }
  };
  return (
    <div className="col-md-6 ">
      <label
        htmlFor={r._id}
        disabled={loading}
        className="p-3 my-2 py-1 card text-center rounded-1 pointer text-muted"
        style={{ border: `dashed 1px ${r?.upload ? "green" : "red"}` }}
      >
        {loading && <Loader />}
        {!loading && <i className="fa fa-folder-open" style={{ fontSize: 45, color: `${r?.upload ? "green" : "red"}` }} />}
        {r?.label}
        <input type="file" id={r._id} onChange={_save} style={{ display: "none" }}></input>
      </label>
    </div>
  );
};

export default UploadDoc;
